import { render, staticRenderFns } from "./AccountSendErc20.vue?vue&type=template&id=6d28a39f&"
import script from "./AccountSendErc20.vue?vue&type=script&lang=js&"
export * from "./AccountSendErc20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports